export const AGENT_PROFILE_STATUSES = {
  churned: 'churned',
  active: 'active',
};
